/**
 * A store with nothing in it.
 *
 * Both API-backed providers start here — the internal console's, which then fills it from the
 * backend's projections, and the public surface's, which fills it with the single record the
 * visitor asked about. Neither may import the demo seed (`scripts/check-demo-isolation.mjs`
 * enforces it), so the empty shape lives on its own rather than inside either of them.
 */
import type { DemoDatabase, DemoSettings } from './types';

export function emptyDatabase(): DemoDatabase {
  return {
    templates: [],
    credentials: [],
    batches: [],
    subjects: [],
    eventLog: [],
    deliveries: [],
    settings: {
      issuerProfileId: '',
      issuerProfileAccess: 'ok',
      issuerDisplayName: '',
      linkedinIssuerName: '',
      linkedinPageUrl: '',
      linkedinOrganizationId: null,
      issuerWebsite: '',
      issuerLogoAssetRef: null,
      publicBase: '',
      supportEmail: '',
      email: { senderName: '', fromEmail: '', replyTo: '', sendEnabled: true },
      claim: { tokenValidityDays: 30, tokenBits: 256 },
      privacy: {
        noindex: true,
        publicSearch: false,
        pendingHidesPersonalData: true,
        keepRevokedPages: true,
        unknownCode404: true,
      },
      domainReadiness: {},
    } satisfies DemoSettings,
  };
}
